export const PermissionListLayout = (props: Omit<React.ComponentPropsWithRef<"div">, "className">): React.ReactNode => {
  return <div {...props} className="mb-4 flex flex-wrap gap-x-8 gap-y-4 pl-12 sm:gap-x-12" />;
};

export const PermissionWrapper = (props: Omit<React.ComponentPropsWithRef<"div">, "className">): React.ReactNode => {
  return <div {...props} className="w-full shrink-0 sm:w-40" />;
};
